import {
  http,
} from "./http.js";

async function syncWithERP(id) {
  const response = await http.put(`bas-erp/goods-release/release-orders/${id}/sync`);
  return response;
}

async function getNeedSync(id) {
  const response = await http.get(`bas-erp/goods-release/release-orders/${id}/need-sync`);
  return response;
}

export {
  syncWithERP,
  getNeedSync,
};